import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {Center, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text} from "@chakra-ui/react";


function CancelCardModal({cardId, isOpen, setData, message}) {
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);


    const handleConfirmInitiateTransfer = () => {
        dispatch(setActionType(ACTION_TYPES.CANCEL_CARD));
        dispatch(setActionPayload({
            CardID: cardId
        }))
        setData({isOpen: false});

        onOpenQrAfterGenerate();
    }
    return (
        <Modal isCentered isOpen={open} onClose={() => {
            setData({isOpen: false});
        }
        }>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader textAlign='center' textTransform='uppercase'>
                    <div className="modal-header-image">
                        {<img src="Images/caution.png" alt=""/>}
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Center>
                        <Text textAlign='center' fontSize={16} fontFamily='Poppins Bold'>
                            Are you sure you want to cancel {message}’s card?
                        </Text>
                    </Center>
                    <Center>
                        <Text textAlign='center' color='#7588A0' fontFamily='Poppins Regular'>
                            By canceling the card all transactions related to this card will not be processed.
                        </Text>
                    </Center>
                    <Center>
                        <button
                            id="closeTransferModalBtn"
                            onClick={() => {
                                setData({isOpen: false});
                            }}
                        >
                            Not Now
                        </button>
                        <button
                            id="closeModalBtn"
                            onClick={() => {
                                handleConfirmInitiateTransfer()
                            }}
                        >
                            Delete Card
                        </button>
                    </Center>

                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default CancelCardModal;